import { render, staticRenderFns } from "./VThankYou.vue?vue&type=template&id=7139f3e9&"
import script from "./VThankYou.vue?vue&type=script&lang=js&"
export * from "./VThankYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports